/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_track_another_order = /** @type {(inputs: {}) => string} */ () => {
	return `Zobrazit jinou objednávku`
};

const da_track_another_order = /** @type {(inputs: {}) => string} */ () => {
	return `Se en anden ordre`
};

const de_track_another_order = /** @type {(inputs: {}) => string} */ () => {
	return `Weitere Bestellung anzeigen`
};

const en_track_another_order = /** @type {(inputs: {}) => string} */ () => {
	return `Track another order`
};

const es_track_another_order = /** @type {(inputs: {}) => string} */ () => {
	return `Ver otro pedido`
};

const fr_track_another_order = /** @type {(inputs: {}) => string} */ () => {
	return `Voir une autre commande`
};

const hu_track_another_order = /** @type {(inputs: {}) => string} */ () => {
	return `Másik rendelés megtekintése`
};

const it_track_another_order = /** @type {(inputs: {}) => string} */ () => {
	return `Vedi un altro ordine`
};

const nl_track_another_order = /** @type {(inputs: {}) => string} */ () => {
	return `Bekijk een andere bestelling`
};

const pl_track_another_order = /** @type {(inputs: {}) => string} */ () => {
	return `Zobacz inne zamówienie`
};

const pt_track_another_order = /** @type {(inputs: {}) => string} */ () => {
	return `Ver outro pedido`
};

const sv_track_another_order = /** @type {(inputs: {}) => string} */ () => {
	return `Visa en annan beställning`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const track_another_order = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.track_another_order(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("track_another_order", locale)
	if (locale === "cs") return cs_track_another_order(inputs)
	if (locale === "da") return da_track_another_order(inputs)
	if (locale === "de") return de_track_another_order(inputs)
	if (locale === "en") return en_track_another_order(inputs)
	if (locale === "es") return es_track_another_order(inputs)
	if (locale === "fr") return fr_track_another_order(inputs)
	if (locale === "hu") return hu_track_another_order(inputs)
	if (locale === "it") return it_track_another_order(inputs)
	if (locale === "nl") return nl_track_another_order(inputs)
	if (locale === "pl") return pl_track_another_order(inputs)
	if (locale === "pt") return pt_track_another_order(inputs)
	return sv_track_another_order(inputs)
};